import React from 'react';
import styles from './styles.module.scss'
import classNames from "classnames";

interface IconImageProps {
  asset?: string;
  alt?: string;
  className?: string | undefined;
  classNameForContainer?: string | undefined;
  onClick?: () => void
  disabled?: boolean
  icon?: React.ReactNode
}

const IconButton: React.FC<IconImageProps> = ({
                                                asset,
                                                alt,
                                                className,
                                                classNameForContainer,
                                                onClick,
                                                disabled,
                                                icon
                                              }) => {
  return (
    <div className={classNames(styles.button, classNameForContainer, className)} onClick={disabled ? undefined : onClick}>
      {icon || <img className={classNames(styles.icon, className)} src={asset} alt={alt}/>}</div>);
}

export default IconButton;